// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"8fab5d9c2d6a6a955a72","303":"05925fd231a7a5576cb9","495":"39c8f0e31aebbd2fe653"}[chunkId] + ".js";
};